module.exports = __webpack_public_path__ + "static/logo-7554253186fa775908a9a50cc34fa4e7.png";